module.exports = __webpack_public_path__ + "static/a-xx-001-art-58f946342077b2fe8c5855fb59a9a79b.jpg";